module.exports = __webpack_public_path__ + "img/tracking-pc.4c4391e5.png";